import {
  GET_CLIENT_EMAIL_EVENTS,
  GET_CLIENT_EMAIL_EVENTS_SUCCESS,
  GET_CLIENT_EMAIL_EVENTS_ERROR,
  GET_CLIENT_EMAIL_TEMPLATE_BY_ID,
  GET_CLIENT_EMAIL_TEMPLATE_BY_ID_SUCCESS,
  GET_CLIENT_EMAIL_TEMPLATE_BY_ID_ERROR,
  CHECK_CLIENT_EMAIL_STATUS_BY_EVENT,
  CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS,
  CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR,
  DELETE_CLIENT_EMAIL_STATUS_BY_EVENT,
  DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS,
  DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR,
} from "./actionTypes"

export const getClientEmailEvents = (query_params, paginated) => {
  return {
    type: GET_CLIENT_EMAIL_EVENTS,
    payload: query_params,
    paginated: paginated
  }
}
export const getClientEmailEventsSuccess = (event, meta) => ({
  type: GET_CLIENT_EMAIL_EVENTS_SUCCESS,
  payload: event,
  meta,
})

export const getClientEmailEventsError = (error) => ({
  type: GET_CLIENT_EMAIL_EVENTS_ERROR,
  payload: error
})

export const getClientEmailTemplateById = (event) => ({
  type: GET_CLIENT_EMAIL_TEMPLATE_BY_ID,
  payload: event
})

export const getClientEmailTemplateByIdSuccess = (event) => ({
  type: GET_CLIENT_EMAIL_TEMPLATE_BY_ID_SUCCESS,
  payload: event
})

export const getClientEmailTemplateByIdError = (error) => ({
  type: GET_CLIENT_EMAIL_TEMPLATE_BY_ID_ERROR,
  payload: error
})

export const checkClientEmailStatuByEvent = (event) => ({
  type: CHECK_CLIENT_EMAIL_STATUS_BY_EVENT,
  payload: event
})

export const checkClientEmailStatuByEventSuccess = (event) => ({
  type: CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS,
  payload: event
})

export const checkClientEmailStatuByEventError = (error) => ({
  type: CHECK_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR,
  payload: error
})

export const deleteClientEmailStatusByEvent = (event) => ({
  type: DELETE_CLIENT_EMAIL_STATUS_BY_EVENT,
  payload: event
})

export const deleteClientEmailStatusByEventSuccess = (event) => ({
  type: DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_SUCCESS,
  payload: event
})

export const deleteClientEmailStatusByEventError = (error) => ({
  type: DELETE_CLIENT_EMAIL_STATUS_BY_EVENT_ERROR,
  payload: error
})
